import React from "react";
import { Chip } from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";

function MyChip({ icon, ...props }) {
  return <Chip {...props} deleteIcon={<CloseRoundedIcon />} icon={icon ? <img src={icon} style={{ marginRight: "8px" }} /> : null} />;
}

export default MyChip;
